import type { FC } from 'react';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { extendAnalyticsData, useSportUrlParams } from '@mwl/core-lib';
import { filterAnalytics } from '@/Layouts/SportLayout/components/SportToolbar/components/FilterAndSearch/FilterAndSearch.analytics';
import { FilterMobileButton } from '../../../FilterMobileButton/FilterMobileButton';
import { FiltersGroup } from '../FiltersGroup/FiltersGroup';
import { SportSearchInput } from '../SportSearchInput/SportSearchInput';
import type { FilterAndSearchProps } from './FilterAndSearch.types';
import styles from './FilterAndSearch.module.scss';
export const FilterAndSearch: FC<FilterAndSearchProps> = ({
  searchRef,
  searchViewState,
  inputValue,
  ...params
}) => {
  const {
    t
  } = useTranslation('sport');
  const {
    search
  } = useSportUrlParams();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const buttonText = t('filter_title', 'Filter');
  const handleChangeIsFilter = useCallback(() => {
    setIsFilterOpen(current => !current);
  }, []);
  return <div className={styles.root} data-sentry-component="FilterAndSearch" data-sentry-source-file="FilterAndSearch.tsx">
      <div ref={searchRef} className={cn(styles.searchContainer, {
      [styles.overflowHidden]: !inputValue && searchViewState !== 'typing' || search
    })}>
        <SportSearchInput isMobile className={cn(styles.search, {
        [styles.active]: searchViewState !== 'default'
      })} searchViewState={search ? 'default' : searchViewState} searchRef={searchRef} inputValue={inputValue} {...params} data-sentry-element="SportSearchInput" data-sentry-source-file="FilterAndSearch.tsx" />

        <FilterMobileButton className={cn(styles.filterButton, {
        [styles.hiddenFilter]: searchViewState !== 'default'
      })} title={buttonText} isFilterOpen={isFilterOpen} selectedAmount={0} onFilterClick={handleChangeIsFilter} analytics={extendAnalyticsData(filterAnalytics, {
        text: buttonText
      })} data-sentry-element="FilterMobileButton" data-sentry-source-file="FilterAndSearch.tsx" />
      </div>
      {isFilterOpen && <FiltersGroup />}
    </div>;
};